import { GeoJsonLayer } from "@deck.gl/layers";

import type { ComparisonArea, LabelGeoJSON } from "~/lib/map/types";
import { geoJsonsToCharacterSet } from "./geoJsonsToCharacterSet";

const comparisonAreaToGeoJsonFeatures = (comparisonArea: ComparisonArea): GeoJSON.Feature[] => {
  if (comparisonArea.geometry?.type === "FeatureCollection") {
    return comparisonArea.geometry.features;
  }
  return [
    {
      type: "Feature",
      properties: null,
      geometry: comparisonArea.geometry,
    },
  ];
};

const comparisonAreaToLabelGeoJson = (comparisonArea: ComparisonArea): LabelGeoJSON | null => {
  if (!comparisonArea.coords) {
    return null;
  }

  const { lat, lng } = comparisonArea.coords;
  const { label, geoItemId } = comparisonArea;
  return {
    type: "Feature",
    properties: { label, geoItemId },
    geometry: {
      type: "Point",
      coordinates: [lng, lat],
    },
  };
};

export const initComparisonAreaViewLayers = (comparisonAreas: ComparisonArea[]) => {
  const filteredComparisonAreas = comparisonAreas.filter((area) => area.isShow);
  const labelGeoJsons = filteredComparisonAreas
    .map((area) => comparisonAreaToLabelGeoJson(area))
    .filter((geoJson): geoJson is LabelGeoJSON => geoJson !== null);

  return [
    new GeoJsonLayer({
      id: "comparison-area-view-polygons-layer",
      data: filteredComparisonAreas.flatMap((area) => comparisonAreaToGeoJsonFeatures(area)),
      stroked: false,
      filled: true,
      extruded: false,
      getFillColor: [160, 150, 150, 180],
    }),
    new GeoJsonLayer({
      id: "comparison-area-label-layer",
      data: labelGeoJsons,
      stroked: false,
      filled: true,
      extruded: false,
      pointType: "text",
      getText: (d: LabelGeoJSON) => d.properties.label ?? null,
      getTextColor: [197, 48, 48],
      textFontFamily: "system-ui,SFMono-Regular,Menlo,Monaco,Consolas,monospace",
      getTextSize: 16,
      textSizeScale: 0.6,
      textFontWeight: 600,
      textLineHeight: 1.2,
      textBackground: true,
      textBackgroundPadding: [8, 6, 8, 6],
      getTextBackgroundColor: [255, 255, 255, 180],
      textCharacterSet: geoJsonsToCharacterSet(labelGeoJsons),
    }),
  ];
};
